export default __webpack_public_path__ + "static/offer-office-fa80028c9565ff263d87dda4ff056276.png";